import { ModalidadGrupoTarifa, RentaTarifa, TipoAlojamientoGrupoTarifa, TiposAlojamientos } from 'src/gql/schema'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
// import { getDateRange } from '../../helpers/dateRange'
// import { useDate } from 'src/shared/hooks/useDate'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'
import { capitalize } from 'src/shared/helpers/capitalize'
import { useFormatDate } from 'src/shared/hooks/useFormatDate'

const EstanciaDetail = ({ tarifas, tipo_hospedaje }: { tarifas: RentaTarifa[], tipo_hospedaje: TiposAlojamientos }) => {
    const { formatCustomDate } = useFormatDate()
    const first = tarifas[0]
    const isHotel = first.tarifa?.grupo_tarifa?.tipo_alojamiento === TipoAlojamientoGrupoTarifa.Hotel
    const totalSum = tarifas.reduce((sum, t) => sum + (t.subtotales?.total || 0), 0)
    const nochesSum = tarifas.reduce((sum, t) => sum + (t.subtotales?.noches || 0), 0)

    return (
        <>
            <DetailRow>
                {
                    first.tarifa?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base ?
                        <DetailText type='bold' style={{ maxWidth: "200px" }}>{capitalize(first.tarifa?.grupo_tarifa?.modalidad)}</DetailText> :
                        <DetailText type='bold' style={{ maxWidth: "200px" }}>{capitalize(first.tarifa?.grupo_tarifa?.modalidad || "")} -  {first.tarifa?.grupo_tarifa?.nombre || ""}</DetailText>
                }
                <DetailText type='bold' textAlign='right' style={{ maxWidth: "85px" }}>
                    {formatCurrencyToFixed(totalSum)}
                </DetailText>
            </DetailRow>
            <DetailRow>
                <DetailText>
                    {isHotel
                        ? `${nochesSum} noches | ${formatCurrencyToFixed(first.subtotales?.precio_unitario || 0)}`
                        : `${first.tarifa?.grupo_tarifa?.duracion} horas | ${formatCurrencyToFixed(first.subtotales?.precio_unitario || 0)}`
                    }
                </DetailText>
            </DetailRow>
            {tipo_hospedaje === TiposAlojamientos.Hotel && tarifas.map((t, i) => (
                <DetailRow key={i}>
                    <DetailText textSize={10}>
                        {(t.subtotales?.noches || 0) > 1
                            ? `${formatCustomDate(t.fecha_inicio.slice(0, 10), "MMM, DD")} - ${formatCustomDate(t.fecha_fin.slice(0, 10), "MMM, DD")}`
                            : `${formatCustomDate(t.fecha_inicio.slice(0, 10), "MMM, DD")}`
                        }
                    </DetailText>
                </DetailRow>
            ))}
        </>
    )
}

export default EstanciaDetail